import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import { WalletProvider } from "./context/WalletContext.jsx";
import { startChainClock } from "./utils/chainClock.js";
import "./index.css";

// Boot the single chain clock before first paint so every time-sensitive
// figure (interest, maturity, lifecycle) keys off chain time from the
// very first render — not the browser wall clock. See utils/chainClock.js.
startChainClock();

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <BrowserRouter>
            <WalletProvider>
                <App />
            </WalletProvider>
        </BrowserRouter>
    </React.StrictMode>
);